




















































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { identity, isEmpty, isUndefined } from "lodash";
import { storeSoap } from "@/store/modules/soap";
import { storeUnit } from "@/store/modules/unit";
import { storeKonsul } from "@/store/modules/konsul";
import DataKonsul from "@/services/DataKonsul";
// import User from "@/utility/User";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storeDokter } from "@/store/modules/dokter";
import SoapRanapStore from "@/store/modules/SoapRanapStore";
import { storePasien } from "@/store/modules/pasien";
import CardSuratKonsul from "../pemeriksaan/konsulRujukan/CardSuratKonsul.vue";
import SuratKonsul from "@/services/new/SuratKonsul";

@Component({
  components: {
    CardModalTtd
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class InputKonsulRanapModal extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly title: string;
  @Prop() err!: object;
  @Prop() register!: string;
  @Prop() dataSoap: object;
  @Prop() dataKonsul!: string;
  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }
  unitTujuan = {};
  dokterTujuan = null;
  ksmTujuan = null;
  diagnosis = "";
  masalah = "";
  konsultasi = "";
  validasi = [v => !!v || "*Kolom ini harus diisi"];
  sess_login = this.stateuser;
  soap: object = {};
  type = "konsul";

  mounted() {
    if (userModule.user.unit_id >= "50") {
      this.type = "konsul";
    }
  }

  get stateuser() {
    return userModule.user;
  }

  get statekonsul() {
    return storeKonsul.konsul;
  }

  get statedetailkonsul() {
    return storeKonsul.detailkonsul;
  }

  get stateunit() {
    // return storeUnit.unitPagi;
    const items = storeUnit.unitPagi.map(item => {
      return {
        id: item.id,
        nama: item.nama
      };
    });

    items.push({
      id: "ri",
      nama: "Rawat Inap"
    });

    return items;
  }

  get listDokter() {
    return storeDokter.list;
  }

  get statesoapdata() {
    return storeSoap.soap["data"][0];
  }

  get statesoapdetail() {
    return storeSoap.detailSoap;
  }

  get showDokterTujuan() {
    return this.unitTujuan["id"] == "ri";
  }

  get dialog() {
    return this.value;
  }

  set dialog(value) {
    this.$emit("input", value);
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  @Watch("dataKonsul")
  changeDataKonsul() {
    if (this.dataKonsul["type"] == "konsul") {
      this.diagnosis = this.dataKonsul["diagnosis"];
      this.masalah = this.dataKonsul["masalah"];
      this.konsultasi = this.dataKonsul["konsultasi"];
      this.dokterTujuan =
        parseInt(this.dataKonsul["dokter_tujuan"]["id"]) ?? null;
      this.ksmTujuan = this.dataKonsul["ksm_tujuan_id"];
    } else {
      if (this.dataKonsul["unit_tujuan"] == undefined) {
        // console.log("11");
        this.unitTujuan = null;
        this.diagnosis = this.statesoapdetail[0]?.a;
        this.masalah = " ";
        this.konsultasi = " ";
        this.dokterTujuan = null;
        this.ksmTujuan = null;
      } else {
        console.log("dataKOnsul", this.dataKonsul);
        this.unitTujuan = this.dataKonsul["unit_tujuan"];
        this.diagnosis = this.dataKonsul["diagnosis"];
        this.masalah = this.dataKonsul["masalah"];
        this.konsultasi = this.dataKonsul["konsultasi"];

        // this.dokterTujuan = parseInt(this.dataKonsul.dokter_tujuan?.id) ?? null;

        this.$nextTick(() => {
          this.dokterTujuan =
            parseInt(this.dataKonsul["dokter_tujuan"]["id"]) ?? null;
          this.ksmTujuan = "";
        });
      }
    }
  }

  @Watch("unitTujuan")
  changeUnitTujuan(val, oldVal) {
    if (val?.id !== oldVal?.id) {
      this.dokterTujuan = null;
    }
  }

  @Watch("value")
  changeValue(val) {
    if (!val) {
      this.clearInput();
    }
  }

  batal() {
    this.dialog = false;
  }

  get sendParams() {
    return {
      type: this.type,
      register_id: this.register,
      pasien_rm: this.pasien?.rm,
      unit_pengirim_id: this.sess_login.unit_id,
      unit_tujuan_id: this.unitTujuan["id"],
      dr_pengirim_id: this.sess_login.id,
      dr_tujuan_id: this.dokterTujuan,
      ksm_tujuan_id: this.ksmTujuan,
      diagnosis: this.diagnosis,
      masalah: this.masalah,
      konsultasi: this.konsultasi
    };
  }

  clearInput() {
    this.type = "konsul";
    this.dokterTujuan = null;
    this.diagnosis = null;
    this.masalah = null;
    this.konsultasi = null;
  }

  kirim() {
    if (this.readOnly) return;
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      appModule.setLoading(true);

      if (!this.dataKonsul) {
        SuratKonsul.create(this.sendParams).then(resp => {
          appModule.setLoading(false);
          if (resp.data.status == 1) {
            this.$emit("closePanel");
            storeKonsul.actKonsul_on_reg(this.register);
            appModule.NoticeDelay("Berhasil Menyimpan Surat Rujukan Internal");
            this.dialog = false;
          }
        });
      } else {
        SuratKonsul.update(this.dataKonsul["id"], this.sendParams).then(
          resp => {
            appModule.setLoading(false);
            if (resp.data.status == 1) {
              storeKonsul.actKonsul_on_reg(this.register);
              this.$emit("closePanel", this.statekonsul["suratKonsul"].id);
              appModule.NoticeDelay("Berhasil Ubah Surat Rujukan Internal");
              this.dialog = false;
            }
          }
        );
      }
    }
  }
}
